<template>
  <div class="not-yet-highlighted-locations">
    <h2 class="global-h4 not-yet-highlighted-locations__title">Not yet highlighted</h2>

    <p v-if="!props.rows.length" class="not-yet-highlighted-locations__empty">Every location has been highlighted!</p>

    <template v-else>
      <div class="not-yet-highlighted-locations__list">
        <div v-for="row in visibleRows" :key="row.locationId" class="not-yet-highlighted-locations__row">
          <LocationAvatar :src="row.icon" :name="row.name" :size="34" />
          <a class="not-yet-highlighted-locations__name" :href="`#location-highlight-${encodeURIComponent(row.locationId)}`" @click.prevent="emit('selectLocation', row.locationId)">{{ row.name }}</a>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

// Components
import LocationAvatar from "@components/SocialLocations/LocationAvatar.vue";

// Types
import type { LocationHighlightRow } from "@contracts/socialReports";

const props = defineProps<{
  rows: LocationHighlightRow[];
}>();

const emit = defineEmits<{
  (e: "selectLocation", locationId: string): void;
}>();

const visibleRows = computed<LocationHighlightRow[]>(() => props.rows.slice(0, 4));
</script>

<style scoped lang="scss">
// Not yet highlighted locations ==============================================
.not-yet-highlighted-locations {
  height: 100%;
  box-sizing: border-box;
  padding: 22px 24px;
  border: 1px solid #e4e7ec;
  border-radius: 11px;
  background: #fff;

  &__title {
    margin: 0 0 16px;
  }

  &__empty {
    margin: 0;
    color: #667085;
    font: 400 14px/18px sans-serif;
  }

  &__list {
    gap: 12px;
    display: flex;
    flex-direction: column;
  }

  &__row {
    gap: 11px;
    display: flex;
    align-items: center;
  }

  &__name {
    min-width: 0;
    color: #102f41;
    font: 500 14px/17px sans-serif;
    overflow-wrap: anywhere;

    &:hover {
      text-decoration: underline;
    }

    &:focus-visible {
      outline: 2px solid #058587;
      outline-offset: 3px;
    }
  }
}
</style>
